import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "gfu-layout__main gfu-layout__main--extranarrow" }
const _hoisted_2 = { class: "gfu-hd gfu-hd--h1 _mt-6 _mb-5" }
const _hoisted_3 = { class: "_mt-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_comment_item_preview = _resolveComponent("comment-item-preview")
  const _component_empty_state = _resolveComponent("empty-state")
  const _component_load_more_trigger = _resolveComponent("load-more-trigger")
  const _component_box = _resolveComponent("box")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.Resources.Profile.SectionCommentsHeader), 1 /* TEXT */),
    _createVNode(_component_box, null, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagedItems, (item) => {
          return (_openBlock(), _createBlock(_component_comment_item_preview, _mergeProps({
            key: item.commentID
          }, { ref_for: true }, item, {
            class: "_mb-4",
            nickname: $props.nickname,
            "user-url-name": $props.userUrlName,
            "avatar-url": $props.avatarUrl,
            "user-id": $props.userID
          }), null, 16 /* FULL_PROPS */, ["nickname", "user-url-name", "avatar-url", "user-id"]))
        }), 128 /* KEYED_FRAGMENT */)),
        (!_ctx.hasPagedItems)
          ? (_openBlock(), _createBlock(_component_empty_state, {
              key: 0,
              title: _ctx.Resources.Profile.EmptyStateCommentsTitle,
              "data-qa": "user-profile:EmptyState"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, _toDisplayString($options.emptyStateMessage), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["title"]))
          : _createCommentVNode("v-if", true),
        (_ctx.hasMorePagedItems)
          ? (_openBlock(), _createBlock(_component_load_more_trigger, {
              key: 1,
              onLoadMore: $options.onLoadMore
            }, null, 8 /* PROPS */, ["onLoadMore"]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_progress_overlay, { visible: _ctx.isProcessing }, null, 8 /* PROPS */, ["visible"])
  ]))
}